var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',[(_vm.tasks.length > 0)?_c('div',_vm._l((_vm.tasks),function(task){return _c('div',{key:task.id},[_c('Task',{staticClass:"has-background-white rounded-lg px-md py-sm mb-xxs",attrs:{"task":task}})],1)}),0):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }